// import { apiCall } from "../../../crud/api.crud"

const createLogin = (set) => ({
  login: async (data) => {
    set({ user: data });
  },
});

export default createLogin;
